import React from 'react';
import { t } from 'i18n';

import InputGroup from 'Components/Forms/InputGroup';
import Button from 'Components/Base/Button';

const i18nOpts = { scope: 'care_plan_creators.check_in_templates.questions' };

const Option = ({
  index,
  score,
  text = '',
  setText,
  editing,
  setIsDeleteModalOpen,
  setDeleteResponseIndex,
  canDelete,
}) => {
  const maxLength = 50;

  return <li className='likert_scale_option'>
    <div className="option-input-wrapper">
      <div className="option-index">{score}</div>
      <div className="option-inputs">
        <div>
          <InputGroup
            component="input"
            name="text"
            placeholder={t('placeholders.short_description', i18nOpts)}
            value={text}
            onChange={setText}
            required
            maxLength={maxLength}
            className="option-text"
            type="text"
          />
          <span className="character-count">{maxLength - text.length}</span>
          {canDelete && !editing && (
            <Button
              onClick={() => {
                setDeleteResponseIndex(index);
                setIsDeleteModalOpen(true);
              }}
              className="btn btn--link"
              text={t('delete_response', i18nOpts)}
            />
          )}
        </div>
      </div>
    </div>
  </li>;
};

export default Option;
